import {
    DocumentsFilterSelectValue,
    ImportEmployerDocumentsFilter,
    ImportEmployerDocumentsFilterType,
} from "../../EmployeeServiceTypes";
import { IterUtils } from "../../../../../Common/IterableUtils";

export const getSelectedFilterValueByType = (
    filterType: ImportEmployerDocumentsFilterType,
    selectValues: ImportEmployerDocumentsFilter["selectValues"]
): string | number | undefined => IterUtils.first(selectValues[filterType] ?? [])?.value;

export const getFilterSelectValue = (
    selectedValue: string | number | undefined,
    filterSelectValues: DocumentsFilterSelectValue[]
): DocumentsFilterSelectValue | undefined => filterSelectValues.find(it => it.value === selectedValue);
